// extracted by mini-css-extract-plugin
export default {"base":"TitleDialog_base__YLhNR"};